import { render, staticRenderFns } from "./PacketEdit.vue?vue&type=template&id=153bc400&"
import script from "./PacketEdit.vue?vue&type=script&lang=js&"
export * from "./PacketEdit.vue?vue&type=script&lang=js&"
import style0 from "./PacketEdit.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports